var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import appLogo from 'assets/appLogo.svg';
import { Loading } from './Loading/Loading';
import styles from './AppLoading.module.scss';
export function AppLoading() {
    return (_jsx("div", { children: _jsx("div", __assign({ className: styles.splash }, { children: _jsxs("div", __assign({ className: styles.splash_container }, { children: [_jsx("img", { src: appLogo, alt: "Pub Layer Logo" }), _jsx("h1", { children: "Publication Layer" }), _jsx("div", __assign({ className: styles.progress }, { children: _jsx(Loading, {}) }))] })) })) }));
}
